import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate, Link } from 'react-router-dom';
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
import Select from 'react-select';
const AddInformation = () => {
  const ok2 = Cookies.get('apikey');
  const [lienket, setLienket] = useState('');
  const [disableButton, setDisableButton] = useState(false);
  const [nutorder, setNutorder] = useState('Thêm');
  const [nutxuly, setNutxuly] = useState(null);
  const [info, setInfo] = useState('');
  const [social, setSocial] = useState(null);
  const [options] = useState([
    { text: 'Chọn 1 nền tảng', value: 'vui lòng chọn 1 nền tảng', img: 'https://tecom.pro/img/icon/2383182-200.png' },
    { text: 'Thêm tài khoản chéo Facebook', value: 'facebook', img: 'https://hust.media/img/icon/fbicon.gif' },
    { text: 'Thêm tài khoản chéo TikTok', value: 'tiktok', img: 'https://hust.media/img/icon/tiktok.gif' },
    { text: 'Thêm tài khoản chéo instagram', value: 'instagram', img: 'https://hust.media/img/icon/giphy%20(5).gif' },
    { text: 'Thêm tài khoản chéo threads', value: 'threads', img: 'https://hust.media/img/icon/giphy%20(5).gif' }
    // { text: 'Thêm tài khoản chéo Youtube', value: 'youtube', img: 'https://tecom.pro/img/icon/youtube.png' },
    // { text: 'Thêm tài khoản chéo Threads', value: 'instagram', img: 'https://tecom.pro/img/icon/youtube.png' }
  ]);
  const navigate = useNavigate();
  function switch_router(link) {
    navigate(link);
  };
  useEffect(() => {
    // setOk2(document.cookie.split('=')[1]);
    // postscribe('#themquangcao', '<script src="https://www.vipads.live/vn/c-726-25.js"></script>');
  }, []);

  const asdasdkas = (info) => {
    if (info.status == 3 || info.status == 0) {
      alert_error(info.message);
    } else if (info.status == 1) {
      alert_success(info.message);
    } else if (info.status == 7) {
      alert_success(info.message);
      switch_router('/reactapp/insta/listcauhinh?mode=' + social);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        switch_router(info.redirect);
      }, 1500);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setDisableButton(true);
    setNutorder('Please wait a moment 😊');
    setNutxuly(1);

    if (!lienket) {
      alert('Please điền đầy đủ thông tin');
      setNutorder('đặt tiếp luôn nào');
      setDisableButton(false);
      setNutxuly(0);
      return;
    }

    const ajdjnansdla = 'https://hust.media/insta/profile.php';

    axios.post(ajdjnansdla, {
      key: ok2,
      chedo: 'themcauhinh',
      lienket,
      social
    })
      .then(response => {
        setInfo(response.data);
        asdasdkas(response.data);
        setNutorder('đặt tiếp luôn nào');
        setDisableButton(false);
        setNutxuly(0);
      })
      .catch(error => {
        console.log(error);
        setInfo({});
        setNutorder('đặt tiếp luôn nào');
        setDisableButton(false);
        setNutxuly(0);
      });
  };
  const [isOpen, setIsOpen] = useState(true);

  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  const handleOptionChange = (selectedOption) => {
    setIsOpen(false);
    const selectedOptionpro = selectedOption.value;
    console.log(selectedOptionpro);
    setSocial(selectedOptionpro);
    const selectedOptionok = options.find((option) => option.id == selectedOptionpro);
    // console.log(selectedOption);
    // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
  };
  return (
    <div className="row fixrow">
      <div className="max-h-16">
        <div className="cards">
          {/* <Adsense
            data-ad-client="ca-pub-4574266110812955"
            data-ad-slot="8795043992"
            data-full-width-responsive="no"
            ins-class="display: block; height: 50px;"
            ins-style="display: block; height: 50px;"
            data-ad-format="horizontal"
          /> */}
        </div>
      </div>

      <div className="col mt-0">
        <div className='mt-2 mx-2 items-center justify-center from-teal-100 via-teal-300 to-teal-500'>
          <div className='w-full max-w-lg px-10 py-8 mx-auto bg-white rounded-lg shadow-xl'>
            <div className='max-w-md mx-auto space-y-6'>
              {social === 'facebook' && (
                <p className="text-xs">Điều kiện thêm nick Facebook: <br />
                  - Tên đầy đủ ảnh bìa, đại diện, thông tin <br />
                  - Hoạt động hơn 7 ngày<br />
                  - Tham gia 1 nhóm <br />
                  - Điều kiện chung: Tên Tiếng Việt hoặc nước ngoài, đầy đủ ảnh bìa, ảnh đại diện, thông tin, đăng 3 bài <br />
                  - Làm job vip: Điều kiện chung + Đã từng đổi ảnh đại diện 2 lần + ảnh cũ nhất trên 15 ngày <br />
                  - Làm job thường: Điều kiện chung + Ảnh cũ nhất trên 3 ngày <br />
                  - Trên 20 bạn bè <br />
                  - Phí thêm tải khoản chéo facebook là 34 Coins
                </p>
              )}
              {social === 'tiktok' && (
                <p className="text-xs">Điều kiện thêm nick TikTok: <br />
                  - Điều kiện chung: Tài khoản công khai, tên Tiếng Việt hoặc nước ngoài, đầy đủ ảnh đại diện, thông tin bio <br />
                  - Làm job vip: Điều kiện chung + Lập trên 4 tháng hoặc lập trên 2 tháng + đăng trên 3 video <br />
                  - Làm job thường: Điều kiện chung <br />
                  - Mỗi lần thêm hết 34 Coins
                </p>
              )}
              {(social === 'instagram' || social === 'threads') && (
                <p className="text-xs">
                  Điều kiện thêm Nick: <br />
                  - Tên Tiếng Việt, đầy đủ ảnh đại diện, thông tin tiểu sử (bio)<br />
                  - Có ít nhất 1 người theo dõi<br />
                  - Mỗi lần thêm miễn phí
                  <br />
                </p>
              )}
              {social === 'youtube' && (
                <p className="text-xs">
                  Điều kiện thêm Nick Youtube: <br />
                  - Tên Tiếng Việt, đầy đủ ảnh đại diện, thông tin<br />
                  - Nếu có ảnh đại diện rồi vẫn báo lỗi thì đổi 1 ảnh khác<br />
                  <br />
                </p>
              )}
              <form onSubmit={onSubmit} className="add-form">
                <div className="form">
                  <label htmlFor="countries2" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Chọn nền tảng</label>
                  <Select
                    classNamePrefix="Chọn 1 lựa chọn"
                    onFocus={handleFocus}
                    options={options.map((option) => ({
                      value: option.value,  // Sửa lại chỉ lấy giá trị của social hoặc chuỗi rỗng
                      label: `${option.text}` // Giữ nguyên
                    }))}
                    menuIsOpen={isOpen}
                    onBlur={handleBlur}
                    onMenuOpen={handleMenuOpen}
                    onChange={handleOptionChange}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={false}
                  >
                  </Select>
                </div>
                <br />
                {social === 'facebook' && (
                  <div className="form-control">
                    <label>Nhập liên kết facebook</label>
                    <br />
                    <div className="w-full">
                      <input
                        className="w-full border-2 border-rose-600 h-10"
                        type="text"
                        value={lienket}
                        onChange={(e) => setLienket(e.target.value)}
                        name="lienket"
                        placeholder="Nhập liên kết hoặc id facebook"
                      />
                    </div>
                  </div>
                )}
                {social === 'instagram' && (
                  <div className="form-control">
                    <label>Nhập id instagram</label>
                    <br />
                    <div className="w-full">
                      <input
                        className="w-full border-2 border-rose-600 h-10"
                        type="text"
                        value={lienket}
                        onChange={(e) => setLienket(e.target.value)}
                        name="lienket"
                        placeholder="liên kết hoặc id instagram hoặc threads"
                      />
                    </div>
                  </div>
                )}
                {social === 'threads' && (
                  <div className="form-control">
                    <label>Nhập id threads</label>
                    <br />
                    <div className="w-full">
                      <input
                        className="w-full border-2 border-rose-600 h-10"
                        type="text"
                        value={lienket}
                        onChange={(e) => setLienket(e.target.value)}
                        name="lienket"
                        placeholder="liên kết hoặc id instagram hoặc threads"
                      />
                    </div>
                  </div>
                )}
                {social === 'youtube' && (
                  <div className="form-control">
                    <label>Nhập liên kết youtube</label>
                    <br />
                    <div className="">
                      <input
                        className="w-full border-2 border-rose-600 h-10"
                        type="text"
                        value={lienket}
                        onChange={(e) => setLienket(e.target.value)}
                        name="lienket"
                        placeholder="https://www.youtube.com/@TED hoặc https://youtube.com/channel/UCTHV3WpmvvGrwhotishEWgw"
                      />
                    </div>
                  </div>
                )}
                {social === 'tiktok' && (
                  <div className="form-control">
                    <label>Nhập id tiktok</label>
                    <br />
                    <div className="w-full">
                      <input
                        className="w-full border-2 border-rose-600 h-10"
                        type="text"
                        value={lienket}
                        onChange={(e) => setLienket(e.target.value)}
                        name="lienket"
                        placeholder="Nhập liên kết hoặc id tiktok"
                      />
                    </div>
                  </div>
                )}
                <br />
                <button
                  disabled={disableButton}
                  type="submit"
                  className={`bg-blue-500 w-64 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ${disableButton ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {nutorder}
                </button>
              </form>
              <div id="themquangcao" className="mt-10"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddInformation;
